import { useState } from "react";
import { Alert, Button, Card } from "react-bootstrap";

interface RepairableSection {
  sectionId: number;
  pageId?: number;
  pageableId?: number;
  sectionType?: string;
  message?: string;
  currentContent: any;
  repairEndpoints?: {
    byPageId?: string;
    byPageableId?: string;
  };
}

interface Props {
  title: string;
  detail?: string;
  onRetry: () => void;
  onBack: () => void;
  onRepair?: () => void;
  repairing?: boolean;
  repairableSections?: RepairableSection[];
  onRepairSection?: (section: RepairableSection) => void;
  repairingSectionId?: number | null;
}

function PageLoadErrorState(props: Props) {
  const {
    title,
    detail,
    onRetry,
    onBack,
    onRepair,
    repairing = false,
    repairableSections = [],
    onRepairSection,
    repairingSectionId = null,
  } = props;
  const [expandedSections, setExpandedSections] = useState<Record<number, boolean>>({});

  const toggleSectionContent = (sectionId: number) => {
    setExpandedSections((currentSections) => ({
      ...currentSections,
      [sectionId]: !currentSections[sectionId],
    }));
  };

  return (
    <Alert variant="danger" className="mb-0">
      <Alert.Heading>{title}</Alert.Heading>

      {detail ? <p className="mb-4">{detail}</p> : null}

      {repairableSections.length > 0 ? (
        <div className="d-flex flex-column gap-3 mb-4">
          {repairableSections.map((section) => {
            const isExpanded = Boolean(expandedSections[section.sectionId]);
            const isRepairingSection = repairingSectionId === section.sectionId;

            return (
              <Card key={section.sectionId} className="border-danger">
                <Card.Body>
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <strong>
                        {section.sectionType
                          ? `Seccion ${section.sectionType}`
                          : `Seccion ${section.sectionId}`}
                      </strong>
                      {section.message ? <p className="mb-0 mt-2">{section.message}</p> : null}
                    </div>

                    <div className="d-flex gap-2 flex-wrap">
                      <Button
                        variant="outline-danger"
                        onClick={() => toggleSectionContent(section.sectionId)}
                      >
                        {isExpanded ? "Ocultar contenido actual" : "Ver contenido actual"}
                      </Button>

                      {onRepairSection ? (
                        <Button
                          variant="danger"
                          onClick={() => {
                            const confirmed = window.confirm(
                              "Esta accion reiniciara el contenido de la seccion a una estructura valida vacia. Deseas continuar?"
                            );

                            if (!confirmed) {
                              return;
                            }

                            onRepairSection(section);
                          }}
                          disabled={isRepairingSection}
                        >
                          {isRepairingSection
                            ? "Reparando contenido..."
                            : "Reparar contenido de seccion"}
                        </Button>
                      ) : null}
                    </div>

                    {isExpanded ? (
                      <pre className="mb-0 p-3 bg-light border rounded small overflow-auto">
                        {JSON.stringify(section.currentContent, null, 2)}
                      </pre>
                    ) : null}
                  </div>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      ) : null}

      <div className="d-flex gap-2 flex-wrap">
        {onRepair ? (
          <Button variant="danger" onClick={onRepair} disabled={repairing}>
            {repairing ? "Reparando pagina..." : "Reparar pagina"}
          </Button>
        ) : null}

        <Button variant="outline-danger" onClick={onRetry}>
          Reintentar carga
        </Button>

        <Button variant="secondary" onClick={onBack}>
          Volver al listado
        </Button>
      </div>
    </Alert>
  );
}

export default PageLoadErrorState;